export const RESPONSIVE_RANGES = {
  MOBILE_SMALL: 'mobile_small',
  MOBILE_LARGE: 'mobile_large',
  I_FRAME: 'i_frame',
  DESKTOP_SMALL: 'desktop_small',
  DESKTOP_MEDIUM: 'desktop_medium',
  DESKTOP_LARGE: 'desktop_large',
};

export const RESPONSIVE_BREAK_POINTS = {
  MOBILE_LARGE: 576,
  I_FRAME: 769,
  DESKTOP_SMALL: 920,
  DESKTOP_MEDIUM: 1020,
  DESKTOP_LARGE: 1252,
};

export const SORTING_KEYS = {
  relevance: 'relevance',
  display_date: 'display_date',
  title_asc: 'title_asc',
  plays: 'plays',
  recently_added: 'recently_added',
  rating: 'rating',
};

export const PAGES = {
  HOME: 'HOME',
  CHANNEL: 'CHANNEL',
  MY_VIDEOS: 'MY_VIDEOS',
  FAVORITES: 'FAVORITES',
  ADMINISTRATION: 'ADMINISTRATION',
  SEARCH: 'SEARCH',
};
